const normalizePath = (pathname: string): string => {
  if (!pathname) return "";
  return pathname.split("?")[0].replace(/\/$/, "").toLowerCase() || "/";
};

export function isMmmCallForwardLandingPage(pathname: string): boolean {
  const path = normalizePath(pathname);
  return (
    /^\/gc-[a-z]{2}$/.test(path) ||
    path.startsWith("/gc/") ||
    (path.startsWith("/gs-route/gc/") && !path.startsWith("/gs-route/gc2/"))
  );
}

export function isMmmZipLandingPage(pathname: string): boolean {
  const path = normalizePath(pathname);
  return (
    /^\/gc2-[a-z]{2}$/.test(path) ||
    path.startsWith("/gc2/") ||
    path.startsWith("/gs-route/gc2/")
  );
}

export function isMmmCampaignLandingPage(pathname: string): boolean {
  return (
    isMmmCallForwardLandingPage(pathname) || isMmmZipLandingPage(pathname)
  );
}

export function isMmmCampaignCompareThankYou(
  pathname: string,
  step?: string | null,
  firstLandingPage?: string,
): boolean {
  const path = normalizePath(pathname);
  if (path !== "/compare" || step !== "thankyou") return false;
  return isMmmCampaignLandingPage(firstLandingPage ?? "");
}
